import { onMounted, nextTick, onBeforeUnmount, ref } from 'vue';
import type { Ref } from 'vue';

export function useShowMore(
  presets: Ref<{ $el: HTMLElement } | undefined>,
  presetsList: Ref<HTMLElement | undefined>,
  heightCorrector: number
) {
  const showMore = ref<boolean>(false);
  const isOpened = ref<boolean>(false);
  const style = ref<{ [key: string]: string }>({});

  onMounted(() => {
    window.addEventListener('resize', onResize);
    onResize();
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', onResize);
  });

  const debounce = (fn: Function, ms = 300) => {
    let timeoutId: ReturnType<typeof setTimeout>;
    return function (this, ...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn.apply(this, args), ms);
    };
  };

  const onResize = debounce(() => {
    if (
      presets.value &&
      presetsList.value &&
      presetsList.value.children?.length
    ) {
      const fullElementHeight =
        presetsList.value?.children[0]?.offsetHeight +
        parseFloat(getComputedStyle(presetsList.value?.children[0]).marginTop) +
        parseFloat(
          getComputedStyle(presetsList.value?.children[0]).marginBottom
        );
      showMore.value = presetsList.value.offsetHeight > fullElementHeight;
      if (isOpened.value && presets.value?.$el)
        presets.value.$el.style.height = 'auto';
    }
  }, 250);

  const onShowMore = () => {
    if (showMore.value && presets.value && presetsList.value) {
      isOpened.value = !isOpened.value;
      if (presets.value?.$el) {
        presets.value.$el.style.height = String(presets.value.$el.offsetHeight);
      }
      const newHeight = presetsList.value.offsetHeight - 8;
      nextTick(() => {
        style.value = {
          transition: `height ${Math.floor((newHeight - 44) / 2)}ms ${
            isOpened.value ? 'ease-in' : 'ease-out'
          }`,
          height: (isOpened.value ? newHeight + heightCorrector : 44) + 'px',
        };
      });
    }
  };

  return {
    showMore,
    isOpened,
    style,
    onShowMore,
  };
}
